module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "input-field bd-bot click",
    on: {
      "click": function($event) {
        _vm.showPop = true
      }
    }
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("开户银行 ")]), _vm._v(" "), _c('div', {
    staticClass: "field-content",
    class: _vm.formItem.bankName ? 'color-333' : 'color-999'
  }, [_vm._v(_vm._s(_vm.formItem.bankName || '请选择开户银行'))]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-fanhui1 fs-30 color-999 right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("账号名称")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入账号名称"
    },
    model: {
      value: (_vm.formItem.bankUname),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankUname", $$v)
      },
      expression: "formItem.bankUname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field bd-bot"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("银行账户")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "digit",
      "clearable": true,
      "placeholder": "请输入银行账户"
    },
    model: {
      value: (_vm.formItem.bankNo),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankNo", $$v)
      },
      expression: "formItem.bankNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left required"
  }, [_vm._v("开户行地址")]), _vm._v(" "), _c('van-field', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "clearable": true,
      "placeholder": "请输入开户行地址"
    },
    model: {
      value: (_vm.formItem.bankAddress),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "bankAddress", $$v)
      },
      expression: "formItem.bankAddress"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.dicts['bank_code'],
      "value-key": "codename"
    },
    on: {
      "cancel": function($event) {
        _vm.showPop = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00c49222","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/shopSetting/bankInfo.vue
// module id = D41T
// module chunks = 51